export const mentionedLabel = "rx4eo";
export const repliedLabel = "NoaDQe";
export const forwardedLabel = "qGDqje";
export default {mentionedLabel,repliedLabel,forwardedLabel};